import { getCurrentUserID } from 'src/modules/authentication/storage/user/utils';
import SubjectAPIs from '../../db/subject';
import { EPNodeFieldsResolvers } from '../5-node/fields';
const EPSubjectNodeFieldsResolvers = {
    async attributes(node, context) {
        return SubjectAPIs.getAttributes(getCurrentUserID(), node.id);
    },
};
export const epSubjectFieldsResolvers = {
    EPSubject: {
        ...EPNodeFieldsResolvers,
        ...EPSubjectNodeFieldsResolvers,
    },
};
